import * as React from 'react';
export const starSvg = React.forwardRef(function starSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.005 1.01c.422-.8 1.568-.8 1.99 0l1.87 3.546 3.95.683a1.125 1.125 0 0 1 .615 1.893l-2.794 2.874.571 3.968a1.125 1.125 0 0 1-1.61 1.17L8 13.375l-3.597 1.769a1.125 1.125 0 0 1-1.61-1.17l.57-3.968L.57 7.132a1.125 1.125 0 0 1 .615-1.893l3.95-.683 1.87-3.545ZM8 2.876l-1.461 2.77c-.163.308-.46.523-.803.583l-3.086.534 2.183 2.245c.243.25.356.599.306.944l-.445 3.1 2.81-1.382c.313-.154.68-.154.992 0l2.81 1.381-.445-3.099c-.05-.345.063-.694.306-.944l2.183-2.245-3.086-.534a1.125 1.125 0 0 1-.803-.584L8 2.875Z',
    }),
  );
});
starSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var star = {
  category: 'icon',
  colorable: true,
  name: 'star',
  svg: starSvg,
};
